import { FC, useRef, useState } from "react";

import { useFormContext, useWatch } from "react-hook-form";

import { useRateFieldName } from "../../../hooks/useRateFieldName";
import { CategoriesField } from "../../../RateFields/CategoriesField/CategoriesField";
import { getRestorableCategoryIds } from "../../../RateFields/CategoriesField/helpers";
import { RateOptionToggleRow } from "../RateOptionToggleRow";

import { useTranslate } from "@/common/hooks/useTranslate";
import { useRateCategories } from "@/features/LiveFormEditor/Steps/StepTickets/hooks/useRateCategories";
import { StepTicketsFormData } from "@/features/LiveFormEditor/Steps/StepTickets/types";

export const CategoriesRow: FC = () => {
  const { t } = useTranslate();
  const { control, setValue } = useFormContext<StepTicketsFormData>();
  const { categories } = useRateCategories();

  const fieldName = useRateFieldName("categoryIds");
  const categoryIds = useWatch({ control, name: fieldName });

  const [isOn, setIsOn] = useState(() => (categoryIds?.length ?? 0) > 0);
  const stashedIdsRef = useRef<string[]>([]);

  const handleToggle = (checked: boolean) => {
    setIsOn(checked);
    if (checked) {
      const restorableIds = getRestorableCategoryIds(stashedIdsRef.current, categories);
      if (restorableIds.length > 0) {
        setValue(fieldName, restorableIds, { shouldDirty: true });
      }
    } else {
      stashedIdsRef.current = categoryIds ?? [];
      setValue(fieldName, [], { shouldDirty: true });
    }
  };

  return (
    <RateOptionToggleRow
      optionKey="categories"
      checked={isOn}
      onToggle={handleToggle}
      label={t("dashboard", "ticketing.rateOption.categories")}
      tooltip={t("dashboard", "ticketing.categories.field.tooltip")}
      inlineConfig={isOn ? <CategoriesField variant="inline" /> : undefined}
    />
  );
};
